<template>
	<div id="Main">
		<div class="title">
			<p>成都托管中心简介</p>
			<p>about us</p>
		</div>
		<div class="content">
			<van-row type="flex" class="logo" justify="space-between">
				<van-col>
					<van-image width="17rem" height="6rem" fit="contain" :src="url" />
				</van-col>
				<van-col class="text"><i></i>since 1996</van-col>
			</van-row>
			<!-- 			<p class="textp">成都托管中心于1996年6月经成都市体改委《关于组建成都托管中心的批复》（成体改〔1996〕019号）批准设立运营，其主要职能是为非上市公司提供股权集中登记托管及相关股权管理服务。根据四川省人民政府金融办公室《关于核准成都托管中心有限责任公司经营范围的批复》（川府金发〔2014〕291号），经营范围为：企业资产、债权、股权登记托管、过户转让、结算、代理分红、质押股份托管业务。</p>
			<p class="textp">成都托管中心日常工作接受政府各级相关部门的监督管理和政策指导。四川省人民政府《关于发展多层次资本市场服务实体经济的若干意见》（川府发〔2014〕51号）明确要求：“工商行政管理部门要支持成都托管中心做好全省非上市公司股权集中托管及变更登记，探索中小微企业股权质押融资及其他融资模式。”四川省金融工作局、四川省工商局、中国人民银行成都分行、银监会四川监管局联合发布《四川省非上市公司股权质押融资指导意见》（川金发〔2017〕12号），明确成都托管中心是经省政府批准设立、受省金融工作局监管，在全省范围内开展非上市公司股权登记、托管服务的股权托管机构。</p>
			<p class="textp">成都托管中心经过20多年的发展，建立了完善的股权登记托管业务体系和服务机制，在非上市公司股权管理方面具有丰富的业务资源、人才资源和行业经验，是国内同行业公认的业务规模大、体制健全、制度完整、具有全国性影响力的专业性非上市公司股权登记托管机构。</p> -->
			<div v-html="content"></div>
			<div v-if="images&&images.length>0">
				<van-image width="100%" fit="contain" :src="cmsurl+v" v-bind:key="index" v-for="(v,index) in images" />
			</div>
		</div>
		<footerbox></footerbox>
	</div>
</template>
<script>
	import footerbox from '../../components/footer';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			footerbox,
		},
		data() {
			return {
				url: require('../../assets/images/logo.png'),
				introduction: [require('../../assets/images/about/introduction1.png'), require(
					'../../assets/images/about/introduction2.png')],
				content: '',
				images: '',
				cmsurl: 'https://www.cdtg.com.cn/'
			}
		},
		methods: {
			getlist() {
				let t = this;
				axiosPost.getintro()
					.then((res) => {
						window.console.log('getlist----------', res.data.data)
						let data = res.data.data;
						let content = data.content;
						let images = data.images;
						t.content = content;
						t.images = images;
					}).catch((res) => {
						window.console.log(res)
					})
			}
		},
		mounted() {

		},
		created() {
			this.getlist()
		}

	}
</script>

<style lang="scss" scoped>
	#Main {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		text-align: left;
		.title {
			padding: 1.3rem;
			background-color: #f2f3fa;
			text-align: left;
			padding-top: 2.3rem;

			p {
				color: rgba(51, 51, 51, .4);
				font-size: 1.6rem;
			}

			p:first-child {
				font-size: 2rem;
				color: #333333;
			}
		}

		.content {
			flex: 1;
			padding: 1.3rem;
			background: #fff url('../../assets/images/about/introductionbanner.png') no-repeat right center;
			background-size: 100%;

			.logo {
				padding: 1rem 0;

				.text {
					font-size: 1.2rem;
					color: #d9261c;
					text-align: right;
					line-height: 6rem;

					i {
						display: inline-block;
						height: 1px;
						width: 3rem;
						background-color: rgba(191, 191, 191, 1);
						vertical-align: middle;
						margin-right: 5px;
					}
				}
			}

			.textp {
				color: #333333;
				font-size: 1.4rem;
				text-align: left;
				line-height: 2.4rem;
				margin-bottom: 1rem;
			}
		}
	}
</style>
